import { Grid } from '@mui/material';
import { SimpleTable } from '@tassat/ag-grid';
import { SubmitButton } from '@tassat/button';
import React from 'react';

import { useAppSelector } from 'Reducers/store/hooks';
import { getAssetBalances } from 'Selectors/assetBalancesStats';

import { columnDefs } from './assetBalancesGridOptions';
import { AccountBalancesProps } from './types';

const AssetBalances: React.FC<AccountBalancesProps> = ({
    setAssetListOverlayOpen,
    classes
}) => {
    const assetBalancesStats = useAppSelector(getAssetBalances);

    return (
        <Grid
            className={classes.balancesContainer}
            container
        >
            <SimpleTable
                columnDefs={columnDefs}
                defaultColDef={{
                        resizable: true,
                        sortable: true
                    }}
                minHeight={120}
                overlayNoRowsTemplate='No linked accounts'
                rowData={assetBalancesStats}
                title='Asset Balances'
            />
            {assetBalancesStats?.length !== 0 && (
            <div className={classes.seeDetailsButtonContainer}>
                <SubmitButton
                    className={classes.seeDetailsButton}
                    onClick={() => setAssetListOverlayOpen && setAssetListOverlayOpen(true)}
                    text='See Details'
                    type='submit'
                />
            </div>
                )}
        </Grid>
    );
};

export default AssetBalances;